import React from "react";
import "./css/githublink.css";

function Githublink() {
  return (
    <div>
      <a
        href="https://github.com/Ashyleuy/Weather-page-react"
        className="githublink"
      >
        {" "}
        Open source code by Ashleigh Shambrook
      </a>
    </div>
  );
}
export default Githublink;
